import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { getItemDetails } from './PharmacyMedicineService';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import { ArrowLeft } from 'react-feather';
import { useLoader } from '../../_helper/LoaderContext';
import { usePharmacy } from '../../_helper/PharmacyProvider';
import BarcodeDisplay from '../Common/Barcode/BarcodeDisplay';
import BarcodePrintModal from '../Common/Barcode/BarcodePrintModal';
import { Button } from 'react-bootstrap';
import {
	getInteractionsList,
	getPrimaryUseList,
} from './utils/itemListFields';
import { getItemMetaValue, getPackagingDetail } from './utils/productMetaFields';
import { shouldShowItemTaxField } from '../PharmacyManageTax/taxConfigUtils';

const resolveItemType = (item) => {
	if (item?.isOTC === true || item?.isOTC === "true") return "otc";
	if (item?.isUnani === true || item?.isUnani === "true") return "unani";
	return "medicine";
};

const formatListValue = (values) => {
	const list = Array.isArray(values) ? values : [];
	return list.length ? list.join(', ') : '-';
};

const ViewMedicine = () => {
	const { mdcId } = useParams();
	const { t } = useTranslation();
	const history = useNavigate();
	const { setLoading } = useLoader();
	const { pharmacyPOS } = usePharmacy();
	const [medicineDetails, setMedicineDetails] = useState(null);
	const [showBarcodePrint, setShowBarcodePrint] = useState(false);
	const showTaxField = shouldShowItemTaxField(
		pharmacyPOS,
		medicineDetails ? resolveItemType(medicineDetails) : "medicine"
	);

	// ✅ Fetch item details on load
	useEffect(() => {
		const fetchItem = async () => {
			try {
				setLoading(true);
				const body = {
					itemId: mdcId,
					clinicId: pharmacyPOS?.hospital_id,
				}

				const res = await getItemDetails(body);

				// ✅ Access the nested item
				if (res?.data?.data) {
					const item = res.data.data;
					setMedicineDetails(item);
				}
			} catch (error) {
				console.error("Error fetching item:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchItem();
	}, [mdcId]);

	const gotoList = () => {
		history(`${process.env.PUBLIC_URL}/items`);
	}

	// ✅ Simple field renderer
	const renderField = (label, value) => (
		<div className="mb-3">
			<strong>{t(label)}: </strong> {value || "-"}
		</div>
	);

	return (
		<Fragment>
			<Breadcrumbs mainTitle={t('Item Details')} parent={t('Dashboard')} title={t('Item Details')} />
			<Col sm="12">
				<Card>
					<CardHeader className="d-flex justify-content-end align-items-center gap-2">
						{medicineDetails?.barcode && (
							<Button
								variant="outline-primary"
								size="sm"
								onClick={() => setShowBarcodePrint(true)}
							>
								{t("Print Barcode")}
							</Button>
						)}
						<button
							className="btn btn-primary d-flex align-items-center"
							style={{ color: 'white', height: "40px" }}
							to=""
							onClick={gotoList}>
							<ArrowLeft className="me-2" /> {t("Back")}
						</button>
					</CardHeader>
					{/* <CardBody>
						{medicineDetails ? (
							<Row>
								<Col md="6">
									{renderField("Code", medicineDetails.code)}
									{renderField("Product Name", medicineDetails.brandName)}
									{renderField("Salt Name / Composition", medicineDetails.saltName)}
									{renderField("Manufacturer", medicineDetails.manufacturer)}
									{renderField("Form", medicineDetails.productForm)}
									{renderField("Package", medicineDetails.package)}
									{renderField("Quantity", medicineDetails.quantity)}
									{renderField("Currency", medicineDetails.currency)}
								</Col>
								<Col md="6">
									{renderField("Regular Price", medicineDetails.regularPrice)}
									{renderField("Discount (%)", medicineDetails.discount)}
									{renderField("Tax", `${medicineDetails.tax}% (${medicineDetails.taxType})`)}
									{renderField("Selling Price", medicineDetails.salePrice)}
									{renderField("Min Qty Alert", medicineDetails.minQuantityAlert)}
									{renderField("Max Qty Alert", medicineDetails.maxQuantityAlert)}
									{renderField("Note", medicineDetails.note)}
								</Col>
							</Row>
						) : (
							<p>{t("Loading medicine details...")}</p>
						)}
					</CardBody> */}
					<CardBody>
						{/* {medicineDetails?.barcode && (
							<div className="text-center mb-4">
								<BarcodeDisplay value={medicineDetails.barcode} />
							</div>
						)} */}
						<div className="table-responsive rounded">
							<Table className="table-center table-bordered mb-0 table-hover">
								<tbody>
									<tr>
										<th><strong>{t("Code")}</strong></th>
										<td>{medicineDetails?.code || '-'}</td>
									</tr>
									<tr>
										<th><strong>{t("Bar Code")}</strong></th>
										<td>
											{medicineDetails?.barcode ? (
												<>
													{/* <BarcodeDisplay
														value={medicineDetails.barcode}
														width={1.2}
														height={36}
													/> */}
													<div>
														{medicineDetails.barcode}
													</div>
												</>
											) : (
												"-"
											)}
										</td>
									</tr>
									<tr>
										<th><strong>{t("Brand Name")}</strong></th>
										<td>{medicineDetails?.brandName}</td>
									</tr>
									<tr>
										<th><strong>{t("Salt Name / Composition")}</strong></th>
										<td>{medicineDetails?.saltName || '-'}</td>
									</tr>
									<tr>
										<th><strong>{t("Manufacturer")}</strong></th>
										<td>{medicineDetails?.manufacturer || '-'}</td>
									</tr>
									<tr>
										<th><strong>{t("Product Form")}</strong></th>
										<td>{medicineDetails?.productForm || '-'}</td>
									</tr>
									<tr>
										<th><strong>{t("Package")}</strong></th>
										<td>{medicineDetails?.package || '-'}</td>
									</tr>
									<tr>
										<th><strong>{t("Packaging Detail")}</strong></th>
										<td>{getPackagingDetail(medicineDetails) || '-'}</td>
									</tr>
									{/* <tr>
										<th><strong>{t("Value")}</strong></th>
										<td>{getItemMetaValue(medicineDetails) || '-'}</td>
									</tr> */}
									<tr>
										<th><strong>{t("Primary Use")}</strong></th>
										<td>{formatListValue(getPrimaryUseList(medicineDetails))}</td>
									</tr>
									<tr>
										<th><strong>{t("Interactions")}</strong></th>
										<td>{formatListValue(getInteractionsList(medicineDetails))}</td>
									</tr>
									<tr>
										<th><strong>{t("Product Quantity")}</strong></th>
										<td>{medicineDetails?.packageQuantity || '-'}</td>
									</tr>
									<tr>
										<th><strong>{t("MRP")}</strong></th>
										<td>
											{medicineDetails?.regularPrice ? medicineDetails?.regularPrice + ' ' + medicineDetails?.currency : '-'}
										</td>
									</tr>
									{showTaxField && (
										<tr>
											<th><strong>{t("Tax")}</strong></th>
											<td>{medicineDetails?.tax ? `${medicineDetails.tax}%` : "-"}</td>
										</tr>
									)}
									{/* <tr>
										<th><strong>{t("Discount")}</strong></th>
										<td>{medicineDetails?.discount}%</td>
									</tr>
									<tr>
										<th><strong>{t("Sale Price")}</strong></th>
										<td>{Math.floor(medicineDetails?.salePrice)} {medicineDetails?.currency}</td>
									</tr>
									<tr>
										<th><strong>{t("Tax")}</strong></th>
										<td>{medicineDetails?.tax}% ({medicineDetails?.taxType})</td>
									</tr> */}
									{/* <tr>
										<th><strong>{t("Stock Quantity")}</strong></th>
										<td>{medicineDetails?.stockQuantity}</td>
									</tr> */}
									{/* <tr>
										<th><strong>{t("Stock Unit Price")}</strong></th>
										<td>{medicineDetails?.stockUnitPrice} {medicineDetails?.currency}</td>
									</tr>
									<tr>
										<th><strong>{t("Average Purchase Price")}</strong></th>
										<td>{medicineDetails?.avgPurchasePrice} {medicineDetails?.currency}</td>
									</tr> */}
									<tr>
										<th><strong>{t("Min Quantity Alert")}</strong></th>
										<td>{medicineDetails?.minQuantityAlert || '-'}</td>
									</tr>
									{/* <tr>
										<th><strong>{t("Max Quantity Alert")}</strong></th>
										<td>{medicineDetails?.maxQuantityAlert}</td>
									</tr> */}
									{/* <tr>
										<th><strong>{t("Return Quantity")}</strong></th>
										<td>{medicineDetails?.returnQuantity}</td>
									</tr>
									<tr>
										<th><strong>{t("Return Price")}</strong></th>
										<td>{medicineDetails?.returnPrice} {medicineDetails?.currency}</td>
									</tr> */}

									<tr>
										<th><strong>{t("Note")}</strong></th>
										<td>
											{medicineDetails?.note ? medicineDetails?.note : '-'}
											{/* {medicineDetails?.note !== "" ? medicineDetails?.note : "-"}</td> */}
										</td>
									</tr>
								</tbody>
							</Table>
						</div>
						{/* ) : (
						<p>{t("Loading medicine details...")}</p>
						 )} */}
					</CardBody>
				</Card>
			</Col>
			<BarcodePrintModal
				show={showBarcodePrint}
				onHide={() => setShowBarcodePrint(false)}
				product={medicineDetails}
			/>
		</Fragment>
	)
}

export default ViewMedicine